import api from './axiosConfig';

export const fetchUsers = async () => {
    try {
        const response = await api.get('/api/users');
        return response.data;
    } catch (error) {
        throw new Error('Kullanıcıları alırken hata oluştu.');
    }
};

export const fetchWithRetry = async (url, options = {}, maxRetries = 3) => {
    let lastError;
    
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            const response = await api({
                url,
                ...options,
                timeout: 10000 // 10 saniye timeout
            });
            return response;
        } catch (error) {
            lastError = error;
            console.warn(`API isteği başarısız (deneme ${attempt}/${maxRetries}):`, error.message);
            
            if (attempt === maxRetries) {
                throw error;
            }
            
            // Exponential backoff: 1s, 2s, 4s
            const delay = Math.pow(2, attempt - 1) * 1000;
            await new Promise(resolve => setTimeout(resolve, delay));
        }
    }
    
    throw lastError;
}; 